<template>
	<div>
		<navbar
			@reload="reload"
			:data="item"
			:user="user"
			:isAuth="isAuth"
			:type="'show'">
		</navbar>
		<div v-if="media" class="row">
			<div class="col-md-12">
				<div class="panel panel-default">
					<div class="panel-heading">
						{{ media.filename }}
					</div>
					<div class="panel-wrapper collapse in">
						<div class="panel-body">
							<div v-if="link" class="row">
								<div class="col-md-12">
									<template v-if="media.aggregate_type == 'pdf'">
										<iframe
											class="embed-responsive-item"
											:src="link"
											:height="iframe.style.height"
											:width="iframe.style.width"
											frameborder="0"
											@load="resizeIframe($event)"></iframe>
									</template>
									<template v-if="media.aggregate_type == 'image'">
										<img :src="link" class="img-responsive">
									</template>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Navbar from './Navbar'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'navbar': Navbar,
		},
		data () {
			return {
				item: null,
				media: null,
				base64: null,
				link: null,

				iframe: {
					style: {
						width: null,
						height: null,
					},
				}
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			reload() {
				this.getData()
			},
			getData () {
				var id = this.$route.params.id
				if(id) {
					this.$http.get('admin/management/budgets/' + id)
					.then(response => {
						this.item = response.body
						this.getMedia()
					}).catch(response => {
						console.log(response)
					})
				}
			},
			getMedia() {
				var id = this.$route.params.media_id
				if(id) {
					this.$http.get('admin/media/' + id + '/media')
					.then(response => {
						this.media = response.body
						if(this.media.aggregate_type == 'pdf') {
							this.getBlob()
						}
						if(this.media.aggregate_type == 'image') {
							this.getBase64()
						}
					}).catch(response => {
						console.log(response)
					})
				}
			},
			getBlob() {
				this.$http.get('admin/management/budgets/' + this.item.id + '/media/' + this.media.id + '/download', {responseType: 'blob'})
				.then(response => {
					var blob = response.body
					this.loadPdf(blob)
				}).catch(function(response) {
					console.log(response)
				})
			},
			getBase64() {
				var id = this.$route.params.media_id
				if(id) {
					this.$http.get('admin/media/' + id + '/base64')
					.then(response => {
						var base64 = response.body
						this.loadImage(base64)
					}).catch(response => {
						console.log(response)
					})
				}
			},
			loadPdf(blob) {
				var url = URL.createObjectURL(blob)
				this.link = '/libs/pdfjs-dist/web/viewer.html?file=' + encodeURIComponent(url);
			},
			loadImage(base64) {
				this.link = 'data:image/' + this.media.extension + ';base64,' + base64;
			},
			resizeIframe(event) {
				this.iframe.style = {
					width: '100%',
					height: window.innerHeight,
				}
			},
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/management/budgets/views/Viewer.vue